var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnLeave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-user-home--home-geometric-human-person-single-user",
    clipPath: "url(#clip0_37_398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15.2857C14.3669 15.2857 16.2857 13.3669 16.2857 10.9999C16.2857 8.63301 14.3669 6.71423 12 6.71423C9.63307 6.71423 7.71429 8.63301 7.71429 10.9999C7.71429 13.3669 9.63307 15.2857 12 15.2857Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.68002 21.9714C5.44501 20.7157 6.52015 19.6779 7.80209 18.9578C9.08403 18.2377 10.5297 17.8594 12 17.8594C13.4704 17.8594 14.916 18.2377 16.198 18.9578C17.4799 19.6779 18.555 20.7157 19.32 21.9714",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.1429 10.8971C23.1445 10.6592 23.0965 10.4235 23.0021 10.2051C22.9076 9.98669 22.7688 9.79034 22.5943 9.62855L12 -0.142883L1.40573 9.62855C1.23126 9.79034 1.09238 9.98669 0.997933 10.2051C0.903489 10.4235 0.855546 10.6592 0.857156 10.8971V20.4285C0.857156 20.8832 1.03777 21.3192 1.35926 21.6407C1.68075 21.9622 2.11678 22.1428 2.57144 22.1428H21.4286C21.8832 22.1428 22.3193 21.9622 22.6408 21.6407C22.9623 21.3192 23.1429 20.8832 23.1429 20.4285V10.8971Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/on_leave.944add8dde65036a1f05d470f335b31c.svg";